import styled from 'styled-components'

export const LinkButton = styled.button`
    font: inherit;
    font-weight: 400;
    font-size: 12px;
    color: ${({ theme }) => theme.themeColors.main};
    appearance: none;
    cursor: pointer;
    outline: none;
    border: none;
    background: none;
    padding: 0;
    &:hover {
        opacity: 0.8;
    }
    &:active {
        outline-color: ${({ theme }) => theme.themeColors.main};
    }
`
